<template>
  <div class="questionnaire-paper">
    <template>
      <div class="test-box">
        <router-link to="/doctor/baseinfo" tag="div" class="menu-item">
          <div class="menu-text">
            <span>测试上传</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
      </div>
      <div class="test-box">
        <router-link to="/disease/gb95" tag="div" class="menu-item">
          <div class="menu-text">
            <span>测试GB疾病库</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
      </div>
      <div class="test-box">
        <div class="questionnaire-item">
          <div class="qusetion-title"><span>上传面象及病患处照片</span><em>最多上传9张</em></div>
          <div class="anwser">
            <div class="upload-wrapper">
              <div class="upload-item" v-for="(item, index) in faceImgList">
                <span class="delPic" v-if="item.status == 5" @click="delImage(item)">
                  <icon icon-class="close"></icon>
                </span>
                <div class="preview-box">
                  <img :src="item.url" alt="">
                  <div class="image-status" v-if="item.status != 5">上传中</div>
                  <div class="image-done" v-else>上传成功</div>
                </div>
              </div>
              <div class="upload-item uploader" v-show="wxUploadCount>0">
                <div class="uploader-box" @click="wxImgUpload()">
                  <icon icon-class="upload-thin"></icon>
                </div>
              </div>
            </div>
            <div class="upload-tips">
              <p>请使用后置摄像头并关闭美颜功能，每次复诊时请尽量在相同的光源环境下拍摄以避免环境差异造成的影响。</p>
              <p>拍照前请不要化妆。</p>
              <p>请面向自然光线拍照。</p>
            </div>
          </div>
        </div>
        <!--
        <div class="questionnaire-item">
          <div class="qusetion-title"><span class="required">测试微信图片上传</span></div>
          <div class="anwser">
            <div class="upload-wrapper">

              <div class="upload-item uploader" @click="wxImgUpload()">
                <div class="uploader-box" v-if="!tongueFrontPreview">
                  <icon icon-class="upload-thin"></icon>
                  <span>上传</span>
                </div>
                <div class="preview-box" v-else>
                  <img :src="tongueFrontPreview">
                  <div class="upload-status" :class="{'done': tongueFrontFile.status == 5}" v-if="tongueFrontFile && tongueFrontFile.status">{{tongueFrontFile.status | uploadStatus}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
-->


      </div>
      <div class="test-box">

        <div class="questionnaire-item">
          <div class="qusetion-title"><span class="required">原生图片单张上传</span></div>
          <div class="anwser">
            <div class="upload-wrapper">
              <div class="upload-item uploader" id="uploadTongueBack">
                <div class="uploader-box" v-if="!tongueBackPreview">
                  <icon icon-class="upload-thin"></icon>
                  <span>上传</span>
                </div>
                <div class="preview-box" v-else>
                  <img :src="tongueBackPreview">
                  <div class="upload-status" :class="{'done': tongueBackFile.status == 5}" v-if="tongueBackFile && tongueBackFile.status">{{tongueBackFile.status | uploadStatus}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="width: 98%;min-height: 200px;margin:3px auto;display: block;border:solid 1px #ddd;font-size: 14px;word-break:break-all;">
          {{log_text}}

        </div>
      </div>
    </template>

  </div>
</template>

<style lang="less" scoped>
  .test-box{
    margin:10px auto;
    width: 98%;
    border:dashed 1px #ddd;
    padding:10px 0px;
  }

  .questionnaire-paper{
    position: relative;
    z-index: 15;
    padding: 32px 16px 0;
    &.error{
      margin-top: -92px;
    }
    .questionnaire-item{
      margin-bottom: 40px;
      &.selector{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .anwser{
          margin-top: 0;
          .selector-tips{
            font-size: 16px;
            line-height: 16px;
            color: #999;
            svg{
              color: #CCC;
            }
          }
          .selector-value{
            font-size: 16px;
            line-height: 16px;
            color: #333;
          }
        }
      }
      .qusetion-title{
        font-size: 16px;
        line-height: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        em{
          margin-left: 8px;
          font-size: 14px;
          color: #999;
        }
      }
      .anwser{
        margin-top: 12px;
        position: relative;
        .questionnaire-text{
          border: 1px solid #F7F7F7;
          background: #F7F7F7;
          resize: none;
          padding: 12px;
          font-size: 14px;
          line-height: 20px;
          color: #666;
          width: 100%;
          height: 96px;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .limit{
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 12px;
          color: #999;
        }
        .upload-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          margin-bottom: -16px;
          .upload-item{
            position: relative;
            width: 96px;
            height: 96px;
            margin: 0 16px 16px 0;
            &:nth-child(3n){
              margin-right: 0
            }
            &.uploader{
              .uploader-box{
                width: 100%;
                height: 100%;
                border: 1px dashed #CCC;
                background: #F3F3F3;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                border-radius: 4px;
                svg{
                  font-size: 28px;
                  color: #CCC;
                }
                span{
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 8px;
                  color: #CCC;
                }
              }
              .preview-box{
                position: relative;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                // width: 156px;
                width: 100%;
                height: 96px;
                border-radius: 4px;
                overflow: hidden;
                img{
                  width: 100%;
                }
                .upload-status{
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 24px;
                  color: #FFF;
                  font-size: 12px;
                  line-height: 24px;
                  text-align: center;
                  background: rgba(0, 0, 0, .4);
                  transition: all .2s;
                  &.done{
                    background: @xile;
                  }
                }
              }
            }
            .preview-box{
              position: relative;
              width: 100%;
              height: 100%;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;
              border-radius: 4px;
              background: #000;
              img{
                width: 100%;
              }
              .image-status{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: rgba(0, 0, 0, .5);
                color: #FFF;
                text-align: center;
                font-size: 12px;
              }
              .image-done{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 20px;
                line-height: 20px;
                 background: @xile;;
                color: #FFF;
                text-align: center;
                font-size: 12px;
              }
            }
            .delPic{
              position: absolute;
              top: -8px;
              right: -8px;
              width: 20px;
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #DDD;
              border-radius: 50%;
              background: #FFF;
              z-index: 20;
              svg{
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
        .upload-tips{
          margin-top: 16px;
          padding: 12px;
          font-size: 12px;
          line-height: 16px;
          color: #666;
          border: 1px solid #F7F7F7;
          background: #FAFAFA;
          border-radius: 4px;
          p{
            margin-bottom: 8px;
            &:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .next-wrapper{
      padding: 24px 24px 12px;
      background: #F7F7F7;
      margin: 0 -16px;
      .next-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }
  }
</style>

<script type="text/javascript">
  import pageProgress from '@/components/Common/pageScrollProgress'
  export default {
    data() {
      return {
        log_text: '',
        dataDone: false,
        questionnaireDestory: false,
        questionnaireId: this.$route.query.id,
        // 变化
        change: '',
        // 反馈
        feedback: '',
        // 缓解
        relieve: '',
        relieveData: ['是', '否'],
        relieveShow: false,
        //希望改善的症状
        improve: '',
        // 不舒服
        uncomfortable: '',
        // 舌面照
        tongueFrontUploader: null,
        tongueFrontPreview: '',
        tongueFrontFile: {},
        // 舌背照
        tongueBackUploader: null,
        tongueBackPreview: '',
        tongueBackFile: {},
        // 上传面像
        faceUploader: null,
        faceImgList: [],
        faceOssList: [],
        // 上传检查报告
        reportUploader: null,
        reportImgList: [],
        reportOssList: [],

        wxUploadLocalArray: [],
        wxUploadServerArray: [],
        wxUploadCount: 9
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      pageProgress
    },
    created() {
      let _this = this;
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseImage', 'uploadImage']
          });
          wx.checkJsApi({
            jsApiList: ['chooseImage', 'uploadImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function(res) {
              console.log(res)
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            }
          });
        }
      })
      // 初始化图片上传
      this.$nextTick(() => {
        // 单张上传
        this.setUpload(this.tongueBackFile, 'uploadTongueBack', 'tongueBackFile', 'tongueBackPreview');

        // 多张上传

        // this.setMultipleUpload(this.reportUploader, 'reportUploader', 'reportImgList', 'reportOssList');
      })
    },
    methods: {
      wxSyncUpload() {
        let _this = this;
        if (_this.wxUploadLocalArray.length == 0) {
          /*
          alert("上传完成");
          console.log(_this.wxUploadServerArray);
          _this.$root.post('/getWxImgBatch', {
            oss_dir: 'test',
            batch_arr: _this.wxUploadServerArray,
            type: 1
          }).then(data => {
            if (data.status == 1) {
              _this.faceOssList = data.resultArr;
              _this.faceOssList.forEach(item => {
                item.status = 5;
              });

            } else {
              _this.$notify('发送图片失败');
            }
          });
*/



        } else {
          var entry = _this.wxUploadLocalArray.shift();
          _this.wxUploadCount -= 1;
          wx.uploadImage({
            localId: entry.localid,
            isShowProgressTips: 0,
            success: function(res) {
              var serverId = res.serverId
              _this.wxUploadServerArray.push(serverId);

              _this.faceImgList.forEach(item => {
                if (item.localid == entry.localid) {
                  item.serverid = serverId
                }
              });
              console.log("上传第" + entry.localid + '张')

              _this.$root.post('/getWxImg', {
                id: serverId,
                oss_dir: 'test',
                filename: serverId,
                type: 1
              }).then(data => {
                console.log("返回服务端数据")
                console.log(data)
                if (data.status == 1) {
                  _this.faceImgList.forEach(item => {
                    if (item.serverid == serverId) {
                      item.url = data.url;
                      item.status = 5;
                    }
                  });

                } else {
                  _this.$notify('发送图片失败');
                }
              })


              _this.wxSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: _this.wxUploadCount, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            res.localIds.forEach(item => {
              var entry = {
                status: 1,
                localid: item,
                url: item,
                serverid: ''
              };
              _this.wxUploadLocalArray.push(entry);
              _this.faceImgList.push(entry);
            });

            _this.wxSyncUpload();

          }
        });

      },
      // 上传单张函数
      setUpload(obj, id, file, preview) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "image", extensions: "jpg,jpeg,webp,png,bmp"}
            // ],
            // prevent_duplicates: true,
          },
          // 单文件上传
          multi_selection: false,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              console.log("选择图片")
              var str = JSON.stringify(files)
              _this.log_text = str;
              _this.$root.post('/index.php/index/index/savelog', {
                log: str,
                user_id: _this.userInfo.user_id,
                'type': 'before'
              }).then(data => {

              })

              let canUploadFiles = 0;
              files.forEach(file => {
                canUploadFiles++
                //注释掉base64编码缩略图
                /*
                let fileName = file.name;
                _this.$root.previewUploadImage(file, (imgSrc) => {
                  _this[preview] = imgSrc;
                })
                */

              })
              if (canUploadFiles == files.length) {
                _this[file] = files[0];
                _this.$root.setUploadParam(up, '', false, 'v2');
                console.log(_this[file])
              }
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              console.log("设置文件名")
              _this.$root.setUploadParam(up, fileObj.name, true, 'v2');
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              console.log("上传完成")

              if (info.status == 200) {
                let res = JSON.parse(info.response);
                _this[file].path = res.path
                //上传成功后直接用结果图作为预览
                _this[preview] = res.thumb;
                // _this.avatar = res.path;


                var log_obj = res;
                if (log_obj.thumb != '') {
                  log_obj.thumb = 'thumb01'
                }
                var str = JSON.stringify(log_obj)
                _this.$root.post('/index.php/index/index/savelog', {
                  log: str,
                  user_id: _this.userInfo.user_id,
                  'type': 'after'
                }).then(data => {

                })
                _this.log_text += str;
              }
            },
            Error(up, err) {
              console.log("错误接口")
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      // 上传多张张函数
      setMultipleUpload(obj, id, file, finalList) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "image", extensions: "jpg,jpeg,webp,png,bmp"}
            // ],
            // prevent_duplicates: true,
          },
          // 多文件上传
          multi_selection: true,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              console.log(files)
              // 获取当前已上传的图片数量
              let objLength = _this[file].length;
              let canUploadFiles = 0
              files.forEach(item => {
                // 如果本次选中的图片数量超出了9张的限制，则自动删除多出的图片
                if (item.type.indexOf("image/") == -1) {
                  _this.$notify('图片格式不正确');
                  up.removeFile(item)
                  return false;
                } else {
                  objLength++;
                  canUploadFiles++;
                  if (objLength > 9) {
                    up.removeFile(item);
                  };
                  /* 注释掉base64预览
                  let fileName = item.name;
                  _this.$root.previewUploadImage(item, (imgSrc) => {
                    item.previewImage = imgSrc;
                    _this[file].push(item);
                  })
                  */
                }
              })
              if (canUploadFiles == files.length) {
                _this.$root.setUploadParam(up, '', false, 'v2');
              }
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              _this.$root.setUploadParam(up, fileObj.name, true, 'v2');
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              if (info.status == 200) {

                let res = JSON.parse(info.response);
                console.log(res)
                _this[finalList].push(res.path)
                //上传成功后再生成预览
                fileObj.previewImage = res.thumb;
                _this[file].push(fileObj);
                // _this.avatar = res.path;
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },

      // 删除已上传的图片
      delPic(item, obj, ossObj) {
        let index = this[obj].indexOf(item)
        this[obj].splice(index, 1);
        this[ossObj].splice(index, 1);
      },
      delImage(item) {
        let _this=this;
        let index =_this.faceImgList.indexOf(item)
        _this.faceImgList.splice(index, 1);
        _this.wxUploadCount+=1;
      },
      nextStep() {


      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/TestCode.vue